var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardlogo1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.4842,
    cy: 22.4601,
    r: 22.3304,
    fill: "#F0F9FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4447)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.1917,
    height: 26.1917,
    transform: "translate(9.34717 9.48022)",
    fill: "#F0F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3472 20.4802C24.5563 20.4802 26.3472 18.6894 26.3472 16.4802C26.3472 14.2711 24.5563 12.4802 22.3472 12.4802C20.138 12.4802 18.3472 14.2711 18.3472 16.4802C18.3472 18.6894 20.138 20.4802 22.3472 20.4802Z",
    stroke: "#006EC2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3472 32.4802C31.3472 27.5097 27.3177 23.4802 22.3472 23.4802C17.3767 23.4802 13.3472 27.5097 13.3472 32.4802",
    stroke: "#006EC2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.1917,
    height: 26.1917,
    fill: "white",
    transform: "translate(9.34717 9.48022)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardlogo1);
export default __webpack_public_path__ + "static/media/dashboardlogo1.487799ce80500817d027d62634a5f77c.svg";
export { ForwardRef as ReactComponent };